module.exports = __webpack_public_path__ + "img/customer_service.a7077a35.jpg";